"use strict";
exports.__esModule = true;
var memoize_1 = require("./memoize");
var query_1 = require("./query");
function fetch(options) {
    var url = options.url, headers = options.headers, method = options.method;
    var urlWithQuery = options.query
        ? url + '?' + query_1.serializeParams(options.query)
        : url;
    return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open(method || 'GET', urlWithQuery);
        if (headers) {
            for (var headerKey in headers) {
                if (headers.hasOwnProperty(headerKey)) {
                    var headerValue = headers[headerKey];
                    xhr.setRequestHeader(headerKey, headerValue);
                }
            }
        }
        if (options.params) {
            xhr.setRequestHeader('Content-type', 'application/json; charset=utf-8');
            xhr.send(JSON.stringify(options.params));
        }
        else {
            xhr.send();
        }
        xhr.onreadystatechange = function () {
            if (xhr.readyState !== 4) {
                return;
            }
            if (xhr.status !== 200) {
                reject(new Error("Exited with code: " + xhr.status));
            }
            else {
                try {
                    resolve({
                        xhr: xhr,
                        body: JSON.parse(xhr.responseText)
                    });
                }
                catch (err) {
                    reject(new Error('Can not parse response'));
                }
            }
        };
    });
}
exports["default"] = fetch;
exports.memoizedFetch = memoize_1["default"](fetch, { deepCompare: true }); // tslint:disable-line:no-any
//# sourceMappingURL=fetch.js.map